export function buildRaReferralDateParams(dateRange) {
  if (!dateRange?.[0] || !dateRange?.[1]) return {};
  return {
    date_from: dateRange[0].format('YYYY-MM-DD'),
    date_to: dateRange[1].format('YYYY-MM-DD'),
  };
}

export function buildRaReferralQueryParams({ page = 1, limit = 20, range = null, rmUuid = null } = {}) {
  const params = {
    page,
    limit,
    ...buildRaReferralDateParams(range),
  };
  const rm = rmUuid != null ? String(rmUuid).trim() : '';
  if (rm) {
    params.rm_uuid = rm;
  }
  return params;
}
